<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M5.8125 3.46875C5.8125 1.74286 7.21161 0.34375 8.9375 0.34375H12.0625C13.7884 0.34375 15.1875 1.74286 15.1875 3.46875V3.68227C16.1588 3.77118 17.1223 3.88746 18.0771 4.03033C19.5918 4.25696 20.6562 5.57462 20.6562 7.06843V10.228C20.6562 11.4896 19.892 12.6784 18.6393 13.0949C16.0798 13.9458 13.3429 14.4063 10.5 14.4063C7.65715 14.4063 4.92023 13.9458 2.3607 13.0949C1.10796 12.6784 0.34375 11.4896 0.34375 10.228V7.06843C0.34375 5.57462 1.40824 4.25696 2.92287 4.03033C3.87771 3.88746 4.84118 3.77119 5.8125 3.68227V3.46875ZM13.625 3.46875V3.56336C12.5913 3.50059 11.5493 3.46875 10.5 3.46875C9.45068 3.46875 8.4087 3.50059 7.375 3.56336V3.46875C7.375 2.60581 8.07455 1.90625 8.9375 1.90625H12.0625C12.9254 1.90625 13.625 2.60581 13.625 3.46875ZM10.5 12.0625C10.9315 12.0625 11.2812 11.7127 11.2812 11.2813C11.2812 10.8498 10.9315 10.5 10.5 10.5C10.0685 10.5 9.71875 10.8498 9.71875 11.2813C9.71875 11.7127 10.0685 12.0625 10.5 12.0625Z"
				:fill="color" 
			/>
			<path
				d="M1.125 17.1666V14.2541C1.35733 14.3815 1.60518 14.4903 1.86774 14.5776C4.58424 15.4807 7.48751 15.9688 10.5 15.9688C13.5125 15.9688 16.4158 15.4807 19.1322 14.5776C19.3948 14.4903 19.6427 14.3815 19.875 14.2541V17.1666C19.875 18.679 18.7841 20.0078 17.2467 20.2119C15.0391 20.505 12.787 20.6563 10.5 20.6563C8.21299 20.6563 5.9609 20.505 3.75327 20.2119C2.21588 20.0078 1.125 18.679 1.125 17.1666Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgJobs',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>